import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DataTable } from '@/shared/components/data-table';
import type { ReceivingOrder } from '../../types';
import type {
  ReceivingColumnDef,
  ReceivingRenderContext,
} from '../../hooks/useReceivingListTable';

interface ReceivingListViewProps {
  sortedItems: ReceivingOrder[];
  visibleColumns: ReceivingColumnDef[];
  columnFilters: Record<string, string>;
  ctx: ReceivingRenderContext;
  sortKey: string;
  sortDirection: 1 | -1;
  isLoading?: boolean;
  onSort: (key: string) => void;
  onSetColumnFilter: (key: string, value: string) => void;
  onSelectOrder: (o: ReceivingOrder) => void;
  onCreateOrder: () => void;
}

export function ReceivingListView({
  sortedItems,
  visibleColumns,
  columnFilters,
  ctx,
  sortKey,
  sortDirection,
  isLoading,
  onSort,
  onSetColumnFilter,
  onSelectOrder,
  onCreateOrder,
}: ReceivingListViewProps) {
  return (
    <div className="space-y-2">
      <DataTable<ReceivingOrder, ReceivingRenderContext>
        items={sortedItems}
        columns={visibleColumns}
        ctx={ctx}
        columnFilters={columnFilters}
        sortKey={sortKey}
        sortDirection={sortDirection}
        isLoading={isLoading}
        onSort={onSort}
        onSetColumnFilter={onSetColumnFilter}
        onRowClick={onSelectOrder}
        emptyState={
          <>
            No procurement orders found.{' '}
            <Button variant="link" size="sm" onClick={onCreateOrder}>
              <Plus className="h-4 w-4 mr-1" />
              New Order
            </Button>
          </>
        }
      />
    </div>
  );
}
